import React, { Component } from 'react';
import ProfileBanner from 'components/ProfileBanner';
import GetUserDetails from 'components/GetUserDetails';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Footer from 'components/MiniFooter';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { logPageView, initGA } from 'utils/analytics';
import NavOnScroll from 'components/NavOnScroll';
import styles from './Profile.scss';// to import local scss fle
import Session from './../../components/Session';

class Profile extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    history: PropTypes.shape(),
  };
  static defaultProps = {
    history: {},
    attributes: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      showFixedNavbar: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      if (attributes.get('zoneinfo') !== 'STUDENT') {
        history.goBack();
      }
    }
  }
  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line
    if (this.props.attributes.get('sub') && this.props.attributes.get('profile') !== 'PENDING') {
      this.props.history.push('/');
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    const { attributes, history } = nextProps;
    if (attributes.size > 0) {
      if (attributes.get('zoneinfo') !== 'STUDENT') {
        history.goBack();
      }
    }
  }


  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    if (scrollTop > 80) {
      this.setState({ showFixedNavbar: true });
    } else {
      this.setState({ showFixedNavbar: false });
    }
  }
  render() {
    return (
      <div className={cn('row', styles.profileContainer)}>
        {this.state.showFixedNavbar === true ? <NavOnScroll {...this.props} /> : ''}
        <ProfileBanner {...this.props} />
        <GetUserDetails {...this.props} usedFor="athlete" />
        <Footer />
      </div>
    );
  }
}

export default Session(Profile);



// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.js